import React from 'react';
import type { FC } from 'react';

interface CopyIconProps {
    className?: string;
}

export const CopyIcon: FC<CopyIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Copy Icon</title>
            <rect x="3.5" y="5" width="8" height="8" rx="1" />
            <path d="M8.5 4V2C8.5 1.44772 8.05228 1 7.5 1H1.5C0.947715 1 0.5 1.44772 0.5 2V8C0.5 8.55228 0.947715 9 1.5 9H2.5" />
        </svg>
    );
};
